import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/web/Home.vue'
// import Tokens from '../views/web/Tokens.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/token/:slug',
    name: 'Home - Token Detail',
    component: Home
  },
  /* {
    path: '/signup',
    name: 'signup',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/auth/Signup.vue')
  },
  {
    path: '/signupnext',
    name: 'signupnext',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/auth/SignupNext.vue')
  },
  {
    path: '/signin/:type',
    name: 'signin',
    meta: {
      requiresAuth: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/auth/Signin.vue')
  }, */
  {
    path: '/howtobuy',
    name: 'How To Buy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/HowToBuyGuide.vue')
  },
  {
    path: '/promote',
    name: 'Promote',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/Promote.vue')
  },
  {
    path: '/privatesale',
    name: 'Private Sale',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/PrivateSale.vue')
  },
  {
    path: '/privatesale/:id',
    name: 'Private Sale',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/PrivateSale.vue')
  },
  {
    path: '/tokens',
    name: 'Tokens',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/Tokens.vue')
  },
  {
    path: '/tokens/:slug',
    name: 'Token List / Detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/web/Tokens.vue')
  },
  {
    path: '/mytokens',
    name: 'Manage Tokens',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "promote" */ '../views/app/ManageTokens.vue')
  },
  {
    path: '/wallet',
    name: 'My Wallet',
    meta: {
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/app/MyWallet.vue')
  },
  {
    path: '/profile',
    name: 'My Profile',
    meta: {
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/app/MyProfile.vue')
  },
  /* {
    path: '/metamask',
    name: 'metamask',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/app/MetaMaskConnect.vue')
  } */
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
